// src/pages/Privacy.jsx
import React from "react";
import Navigation from "../components/Common/header/Navigation";
import Footer from "../components/Common/footer/Footer";

const Privacy = () => {
    return (
        <div style={{ backgroundColor: "#080808", color: "#e5e5e5", minHeight: "100vh" }}>
            <Navigation />
            <div className="container py-5" style={{ maxWidth: "800px" }}>
                <h1 style={{ color: "#c5a059", fontFamily: "'Cormorant Garamond', serif", marginBottom: "40px", textTransform: "uppercase", letterSpacing: "2px" }}>
                    Privacy Policy
                </h1>

                <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: "0.95rem", lineHeight: "1.8", color: "#a0aec0" }}>
                    <p>We prioritize customer privacy and confidentiality. The information provided during the ordering process is strictly used for order fulfilment, communication, and legal compliance. We do not share customer information with third parties for marketing purposes without explicit consent.</p>

                    <h3 style={{ color: "#f5f0e8", marginTop: "40px", marginBottom: "15px" }}>Data Collection During Checkout</h3>
                    <p>When you place an order on our site—whether logged in or checking out as a guest—you provide us with information such as your name, email address, billing address, delivery address, and phone number.</p>
                    <p>Please ensure the details you provide are accurate. Your email links your orders to you, helping us keep your information secure, up to date, and enabling us to tailor our services to you.</p>

                    <h3 style={{ color: "#f5f0e8", marginTop: "40px", marginBottom: "15px" }}>Account Creation & Guest Checkout</h3>
                    <p>When placing an order as a guest, you will have the option to create a Bundle Madness Hair account. We will use the information you provide at checkout to set up your account—simply choose a password to log in. Make sure your password is strong and not easily guessable to protect your account.</p>
                    <p>Where you proceed as a Guest without creating an account, we will securely store your order details against your email address for fulfillment and customer service purposes. We will repeat this process each time you use the site and place an order using that email address.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Privacy;